export const USERS = {
  newButton: 'users-new-button',
  list: 'users-list',
  row: 'users-row',
  editButton: 'users-edit-button',
  deleteButton: 'users-delete-button',
  formEmail: 'users-form-email',
  formName: 'users-form-name',
  formRole: 'users-form-role',
  formPassword: 'users-form-password',
  formSubmit: 'users-form-submit',
  formCancel: 'users-form-cancel',
};
